import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { HxUiLabelPipe, HxUnitOfMeasureService, UnitOfMeasureModel } from 'hx-services';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzOptionComponent, NzSelectComponent, NzSelectModeType } from 'ng-zorro-antd/select';
import { NgFor } from '@angular/common';

/**
 * Component search product info by search text
 */
@Component({
    selector: 'hx-unit-measure-select',
    templateUrl: './unit-measure-select.component.html',
    styleUrls: ['./unit-measure-select.component.css'],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HxUnitMeasureSelectComponent),
      multi: true
    }],
  imports: [NzSelectComponent, FormsModule, NgFor, NzOptionComponent, HxUiLabelPipe]
})
export class HxUnitMeasureSelectComponent implements OnInit, ControlValueAccessor {

  @Input() hxMode: NzSelectModeType = 'default';
  @Input() isDisabled = false;
  @Input() includeDisabled = true;
  @Output() selectChange = new EventEmitter<UnitOfMeasureModel | UnitOfMeasureModel[] | undefined>();

  options: UnitOfMeasureModel[] = [];
  private selectedVal?: number | number[];

  get selected(): number | number[] | undefined {
    return this.selectedVal;
  }

  set selected(val: number | number[] | undefined) {
    this.selectedVal = val;
    this.onChange(this.selectedVal);
  }

  constructor(
    private uomService: HxUnitOfMeasureService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    const res = await this.uomService.getUnitOfMeasures({limit: 1000});
    this.options = res.list;
  }

  onModelChanged(val: any) {
    if (this.hxMode === 'default') {
      if (this.selected) {
        this.selectChange.emit(this.options.find(p => p.id === this.selected));
      } else {
        this.selectChange.emit();
      }
    } else {
      if (Array.isArray(this.selected)) {
        const ids: number[] = this.selected;
        this.selectChange.emit(this.options.filter(p => ids.includes(p.id)));
      } else {
        this.selectChange.emit([]);
      }
    }
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(obj?: number | number[]): void {
    this.selected = obj;
  }
}
